const Form = require("components/forms/Form");
const Input = require("components/forms/Input");
const Date = require("components/forms/Date");
const Phone = require("components/forms/Phone");
const Address = require("components/forms/Address");
const Section = require("components/forms/Section");
const Select = require("components/forms/Select");
const store = require("stores/UserStore");
const moment = require("moment");
const {observer} = require("mobx-react");
const env = require("services/env");
const Subusers = require("components/forms/Subusers");
const {decodeObservable} = require("helpers/object");
const shortid = require("shortid");

@observer
class StudentProfileForm extends Form {

	/////////////////////////////////
	// Accessors
	/////////////////////////////////

	get successMessage() {
		return "Dine profiloplysninger er blevet opdateret.";
	}

	get actionLabel() {
		return "Gem";
	}

	get shouldWarn() {
		return true;
	}

	get maxBirthdayDate() {
		return moment().toISOString();
		// TODO: Add proper limit
		//return moment().subtract(18, "years").toISOString();
	}

	get levelsOptions() {
		return [{label: "Vælg...", value: ""}].concat(
			env.get("options.levels", []).map(level => {
				return {
					label: level.name,
					value: level.id
				};
			})
		);
	}

	get levelValue() {
		const levels = this.value("levels", []);
		return levels.length > 0 ? levels[0].id : "";
	}

	get subusersValue() {
		return decodeObservable(this.value("subusers", []));
	}

	/////////////////////////////////
	// Methods
	/////////////////////////////////

	send(form) {
		return store.save(new FormData(form));
	}

	value(name, defaultValue = null) {
		return store.get(name, defaultValue);
	}

	/////////////////////////////////
	// Renderers
	/////////////////////////////////

	renderBody() {
		return (
			<div className="form-body">
				<Section title="Generelle informationer">
					<Input label="Fulde navn" type="text" name="name" required={true}
								 defaultValue={this.value("name")} error={this.error("name")}/>

					<Address types="address" componentRestrictions={{country: "dk"}}
									 label="Adresse" name="address" autoComplete="user-address" required={true}
									 defaultValue={this.value("address")} error={this.error("address")} placeholder=""/>

					<Input label="Email" type="email" name="email" required={true}
								 defaultValue={this.value("email")} error={this.error("email")} autoComplete={shortid.generate()}/>

					<Phone label="Telefon" name="phone" required={true}
								 defaultValue={this.value("phone")} error={this.error("phone")}/>

					<Date label="Fødselsdag" type="text" name="birthday" required={true}
								max={this.maxBirthdayDate} defaultValue={this.value("birthday")} error={this.error("birthday")}/>

					<Select label="Vælg dit niveau/klassetrin" name="level_id" defaultValue={this.levelValue}
									options={this.levelsOptions} required={false} error={this.error("level_id")}/>

				</Section>
				<Section title="Undervisningsmodtager">
					<Subusers name="subusers" error={this.errors("subusers")} value={this.subusersValue}/>
				</Section>
			</div>
		);
	}

}

module.exports = StudentProfileForm;



// WEBPACK FOOTER //
// ./resources/js/components/backend/StudentProfileForm.js